import {useNavigate} from "react-router-dom";
import commonStyles from "../commonStyles";
import GuidaOverlay from "./GuidaOverlay";
import React from "react";
import Equally from "../Images/Equally_light.png"
import Individually from "../Images/Individually_light.png"

function MainCard(props) {
    let navigate = useNavigate()

    return(
        <>
            <GuidaOverlay
                isShown = {props.showOverlay}
                images = {[{img: Equally, id: 0}, {img: Individually, id: 1}]}
                toggleOverlay = { props.toggleOverlay }
            />
            <div className="center">
                <div className="card text-center shadow-lg p-3 mt-5 bg-body rounded" style={ commonStyles.starterCard }>
                    <div className="card-body px-4">

                        <h2 className="card-title mb-4" style={commonStyles.cardTitle}>{ props.title }</h2>
                        <div className="d-grid gap-2 p-4">

                            <button
                                onClick={ () => {
                                    navigate(props.btn1To)
                                    props.resetState()
                                }}
                                className="coolbtn" style={ commonStyles.btn }
                            >
                                { props.btn1 }
                            </button>

                            <button onClick={ () => {
                                navigate(props.btn2To)
                                props.resetState()
                            }}
                                    className="coolbtn" style={ commonStyles.btn }
                            >
                                { props.btn2 }
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>

    );
}

export default MainCard